(function (app, ng) {

    app.directive("inputFocus",
        [
            function () {
                return {
                    restrict: "A",
                    link: function (scope, element) {
                        var inputContainer = ng.element(element.parent());

                        element.on("focus",
                            function () {
                                inputContainer.addClass("focus");
                            });

                        element.on("blur",
                            function () {
                                inputContainer.removeClass("focus");
                            });
                    }
                }
            }
        ]);

})(window.app, window.angular); //jshint ignore:line